import { Pipe, PipeTransform } from '@angular/core';
import { take } from 'rxjs';

import { MedicalCenterService } from '../../../medical-center/service/medical-center.service';

@Pipe({
  name: 'languageSelected',
  pure: false,
  standalone: false,
})
export class LanguageSelectionPipe implements PipeTransform {
  private medicalCenterName = '';
  private readonly medicalCenterName$ = this.medicalCenterService.shortName$;

  constructor(private readonly medicalCenterService: MedicalCenterService) {}

  transform(localeCode: string): string {
    const location = window.location.href;
    const index = location.indexOf('/estimates');
    this.medicalCenterName$
      .pipe(take(1))
      .subscribe((x) => (this.medicalCenterName = x));

    if (index !== -1) {
      return `/${localeCode}${location.slice(index, location.length)}`;
    } else if (this.medicalCenterName.length === 0) {
      return `/${localeCode}/`;
    } else {
      return `/${localeCode}?mc=${this.medicalCenterName}`;
    }
  }
}
